export * from '@core/version/public-api';
